import { IconCodeBlock, Plugin, DecoupledEditor, ButtonView } from 'ckeditor5';
import { QualioCodeBlockCommand } from './QualioCodeBlockCommand';
import i18n from '../../../../../i18n/config';

export class QualioCodeBlockPlugin extends Plugin {
  static get pluginName(): string {
    return 'QualioCodeBlockPlugin';
  }

  init(): void {
    const editor = this.editor as DecoupledEditor;
    this.editor.commands.add(QualioCodeBlockCommand.commandName, new QualioCodeBlockCommand(this.editor));
    editor.ui.componentFactory.add(QualioCodeBlockCommand.commandName, (locale: any) => {
      const view = new ButtonView(locale);

      view.set({
        label: i18n.t('templates.ckeditor.insertCodeBlockCaps'),
        icon: IconCodeBlock,
        tooltip: true,
        isToggleable: true,
      });

      view.bind('isEnabled').to(this.editor.commands.get(QualioCodeBlockCommand.commandName)!);

      view.on('execute', () => {
        editor.execute('codeBlock');
        editor.editing.view.focus();
      });
      return view;
    });
  }
}
